export default function getProductUrl(slug) {
  return `/product/${slug}`
}
